import { useMemo } from "react";

import { useCoreChart } from "~/feature/chart/providers/CoreChartProvider";
import { getEventResolution } from "~/feature/chart/utils";
import { formatDate } from "~/utils/formatDate";

import { labelByResolutionState } from "./constants";

export const useResolveDate = () => {
  const { event } = useCoreChart();

  const resolveLabel = useMemo(() => {
    const { isResolved, date } = getEventResolution(event);

    if (!date) {
      return null;
    }

    const prefix = isResolved
      ? labelByResolutionState.resolved
      : labelByResolutionState.upcoming;

    return `${prefix} ${formatDate(date, { dateOnly: true, includeYear: true })}`;
  }, [event]);

  return { resolveLabel };
};
